import { submitPaperApplication } from "api/Customers";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useSubmitPaperApplication = () => {
    const queryClient = useQueryClient();

    return useMutation(submitPaperApplication, {
        onSuccess: () => {
            toast.success("Submmited successfully!");
            queryClient.invalidateQueries('coustomers')

        },
        onError: (error: any) => {
            toast.error(error.response.data.error);
        }

    })
}